/**
 * Logged-out product tile re-design * https:www.notion.so/faire/Discover-page-redesign-Phase-2-f0a9c297f24f49caa518c10a847fd8ef * https:www.figma.com/design/mNfQu9QbjYLVSSiC7kSYkq/Logged-out-product-tiles?node-id=29-1562&t=Xv3BSp2OG16u1Q5L-0
 */
export const ENABLE_LOGGED_OUT_PRODUCT_TILE_REDESIGN_240626 = 'ENABLE_LOGGED_OUT_PRODUCT_TILE_REDESIGN_240626';
